<template>
    <button class="db-table-action db-btn-outline sm default primary transparent modal-btn" >
        <i class="lab lab-line-edit"></i>
        <span class="db-tooltip">{{ $t('button.edit') }}</span>
    </button>
</template>

<script>
export default {
    name: "SmIconModalEditComponent",
}
</script>

<style scoped>

</style>
